jQuery(document).ready(function ($) {

    $('img').each(function () {
        var $img = $(this);
        var altText = $img.attr('alt');
        var src = $img.attr('src');

        // If alt is missing or empty
        if (!altText || altText.trim() === '') {
            if (src) {
                var fileName = src.split('/').pop().split('?')[0];

                var cleanName = fileName
                    .replace(/\.(jpg|jpeg|png|webp|gif|svg)$/i, '')
                    .replace(/[-_]+/g, ' ')
                    .trim();

                $img.attr('alt', cleanName);
            }
        }
    });

});
